import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
  OnInit,
  HostListener,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent  {
  isSmallScreen: boolean = false;
  
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();
  

  showFiller = false;
  itemSelected: any;
  members: any;

  constructor(public dialog: MatDialog) {
    this.checkScreenSize();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isSmallScreen = window.innerWidth <= 768; // Adjust this value according to your desired breakpoint
  }
  logout() {
   
    sessionStorage.clear();


    
  }
  
  onMemberClick(event: Event) {
    const target = event.target as HTMLSelectElement;
    if (target) {
      const value = target.value;
      this.itemSelected = value;
      sessionStorage.setItem("customerId", this.itemSelected);
      this.ngOnInit();
      window.location.reload();
    }
  }
  
  
  getMemberData() {
     const selectedItemId = sessionStorage.getItem('customerId');
    if (selectedItemId) {
      this.itemSelected = selectedItemId;
    }
    const storedMembers = sessionStorage.getItem('MembersData');
    if (storedMembers) {
      this.members = JSON.parse(storedMembers);
    }
    else {
      this.members = [];
    }
  
   
  
    return this.members;
  }
  ngOnInit() {






    
    this.getMemberData();
  }

}

